import {FC, useState} from "react";
import {Button, Checkbox, Popover, Select} from "antd";
import styles from './EventCommentsContent.module.css';
import {EventApprover, User} from "../../../../types/domain.ts";
import {useOwnProfile} from "../../../../stores/OwnProfileStore.ts";
import {getUserOrigin} from "../../../../utils/getUserOrigin.ts";

type Props = {
    userId: number | undefined;
    onSelect: (userId: number | undefined) => void;
    approvers?: EventApprover[];
    createdBy: User;
}

export const PrivateCommentOption: FC<Props> = ({ userId, onSelect, approvers, createdBy }) => {
    const [open, setOpen] = useState(false);
    const { profile } = useOwnProfile();

    const options = [
        ...(approvers || []),
        { user: createdBy }
    ].filter(({ user }) => user && user.id !== profile?.id)
        .map(({ user }) => ({
        label: `${user!.first_name} ${user!.last_name} (${getUserOrigin(user!)})`,
        value: user!.id
    }));

    const content = (
        <Select
            className={styles.selectUser}
            placeholder="Получатель"
            value={userId}
            options={options}
            onChange={(v) => {
                setOpen(false);
                onSelect(v);
            }}
        />
    )

    const handleOpen = (value: boolean) => {
        if(!value) return setOpen(false);
        if(userId) {
            return onSelect(undefined);
        }
        setOpen(true);
    }

    return (
        <Popover
            trigger="click"
            open={open}
            onOpenChange={handleOpen}
            content={content}
            destroyTooltipOnHide
        >
            <Button className={styles.buttonFitContent}>
                <Checkbox checked={Boolean(userId)}>Приватный</Checkbox>
            </Button>
        </Popover>
    )
}